// service to set up functionality on product controls
import {debounce, pipe, toQueryString} from "../../helpers/operators.js";
import {sendGetAjax, sendGetPromise, sendPutPromise} from "../../helpers/sendAjax.js";

let initProductQuantities = {};

const customerPurchaseBlocked = document.querySelectorAll('.js-customer-purchase-blocked').length > 0;

const limitedStockModal = document.querySelectorAll('.product-limited-stock-modal')[0];
const okButton = document.querySelectorAll('.product-limited-stock-modal .js-limited-stock-modal-ok')[0];

okButton.addEventListener('click', () => {
    sendCartAjax(limitedStockModal.dataset.qtyAvailable, limitedStockModal.dataset.unit, limitedStockModal.dataset.code, () => { updateQtyInput(code, qtyAvailable) });
});

const updateQtyInput = (id, value) => {
    const qtyInputs = document.querySelectorAll(`.js-product-qty-${id}`);

    if(value === undefined) {
        value = 0;
    }

    qtyInputs.forEach(input => {
        input.value = value;
        input.setAttribute('value', value);
    });
}

const getCart = () => sendGetPromise(`/dafgards/cart/current`);

const sendCartAjax = (value, unitValue, id, cb) => {
    const cartCountWrap = document.querySelectorAll('.js-mini-cart-count');
    const cartCount = document.querySelectorAll('.js-mini-cart-count span');
    const cart = document.querySelectorAll('.js-mini-cart-link .price');

    const data = pipe(encodeURI, toQueryString)([
        {name: 'qty', value: value},
        {name: 'unitCode', value: unitValue},
        {name: 'productCodePost', value: id},
    ]);

    function getCartEntry(cartData, productCode) {
        return !cartData || !cartData.entries || !productCode ? null : cartData.entries?.find(entry => entry.product.code == productCode);
    }

    function processCartUpdates(cartResponse, existEntry) {
        cart.forEach(node => node.innerHTML = cartResponse?.totalPrice?.formattedValue ?? 0);
        cartCount.forEach(node => node.innerHTML = cartResponse.totalUnitCount ?
            cartResponse.totalUnitCount > 100 ? '99+' : cartResponse.totalUnitCount
            : 0);
        cartCountWrap.forEach(node => node.style.display = 'block');

        updateUnitPrices(id, unitValue);
        initProductQuantities[id] = value;

        setAgreementForProduct(id);

        if (typeof cb === 'function') {
            cb();
        }

        // update analytics dataLayer
        const updatedEntry = getCartEntry(cartResponse, id);
        const initialItemsQty = existEntry ? existEntry.quantity : 0;
        if (updatedEntry && initialItemsQty < updatedEntry.quantity) {
            ACC.gtm.addToCart_gtm(updatedEntry.product.code, updatedEntry.product.name,
                updatedEntry.basePrice.value, updatedEntry.quantity - initialItemsQty);
        }

        if (!updatedEntry && existEntry && initialItemsQty > 0) {
            ACC.gtm.removeFromCart_gtm(existEntry.product.code, existEntry.product.name,
                existEntry.basePrice.value, initialItemsQty);
        }

        if (updatedEntry && initialItemsQty > updatedEntry.quantity) {
            ACC.gtm.removeFromCart_gtm(updatedEntry.product.code, updatedEntry.product.name,
                updatedEntry.basePrice.value, initialItemsQty - updatedEntry.quantity);
        }
    }

    //Before update save current cart data (use it for GA analytics)
    getCart()
        .then(cartBeforeUpdate => {
            const existEntry = getCartEntry(cartBeforeUpdate, id);

            return sendPutPromise(`/dafgards/cart/update?${data}`, {})
                .then(() => getCart())
                .then(e => processCartUpdates(e, existEntry))
                .catch(e => {
                    if (e.status === 409) {
                        updateQtyInput(id, initProductQuantities[id]);
                        if(e.responseJSON.statusCode === 'noStock') {
                            fetchProductSuggestions(id, value, unitValue, showOutOfStockModal);
                        } else if(e.responseJSON.statusCode === 'maxOrderQuantityExceeded') {
                            fetchProductSuggestions(id, e.responseJSON.quantity, unitValue, showLimitedStockModal);
                        }
                    }
                })
        })
};

const fetchProductSuggestions = (id, qty, unit, callback) => {
    sendGetAjax(`${window.origin}/product-references/${id}`, (data) => {
        callback(data, id, qty, unit);
    });
}

const showOutOfStockModal = (data, code, requestedQty, unit) => {
    hideOutOfStockModal();
    hideLimitedStockModal();
    const container = document.querySelectorAll('.product-out-of-stock-modal .js-suggestion-table')[0];
    container.innerHTML = data;
    const controls = document.querySelectorAll(`.product-out-of-stock-modal .js-suggestion-table .js-product-controls`);
    const qty = document.querySelectorAll('.product-out-of-stock-modal .js-suggestion-table .js-suggestion-qty')[0];
    qty.innerHTML = `0`;
    const unitElement = document.querySelectorAll('.product-out-of-stock-modal .js-suggestion-table .js-suggestion-unit')[0];
    unitElement.innerHTML = `${unit}`;
    setFunctionalityOnControls(controls);
    $('#productOutOfStockModal').modal();
}

const hideOutOfStockModal = () => {
    $('#productOutOfStockModal').modal('hide');
}

const showLimitedStockModal = (data, code, qtyAvailable, unit) => {
    hideOutOfStockModal();
    hideLimitedStockModal();
    const container = document.querySelectorAll('.product-limited-stock-modal .js-suggestion-table')[0];
    container.innerHTML = data;
    const controls = document.querySelectorAll(`.product-limited-stock-modal .js-suggestion-table .js-product-controls`);
    const qty = document.querySelectorAll('.product-limited-stock-modal .js-suggestion-table .js-suggestion-qty')[0];
    qty.innerHTML = `${qtyAvailable}`;
    const unitElement = document.querySelectorAll('.product-limited-stock-modal .js-suggestion-table .js-suggestion-unit')[0];
    unitElement.innerHTML = `${unit}`;
    limitedStockModal.dataset.code = code;
    limitedStockModal.dataset.qtyAvailable = qtyAvailable;
    limitedStockModal.dataset.unit = unit;
    setFunctionalityOnControls(controls);
    $('#productLimitedStockModal').modal();
}

const hideLimitedStockModal = () => {
    $('#productLimitedStockModal').modal('hide');
}

const isKarUnit = (unitName) => unitName === 'KAR';
const getProperMinOrderQty = (unitName, minOrderQty) => isKarUnit(unitName) ? 1 : minOrderQty;
const addVal = (value, minOrderQty) => parseInt(value) + minOrderQty;
const removeVal = (value, minOrderQty) => parseInt(value) - minOrderQty;
const minStep = (value, minOrderQty) => {
    const diff = parseInt(value) % minOrderQty;
    if (diff !== 0) {
        return (parseInt(value) + minOrderQty - diff);
    }
    return value;
};

const setFunctionalityOnControls = controls => {
    controls.forEach(control => {
        const id = control.dataset.id;
        const qtyInput = control.querySelectorAll(`.js-product-qty-${id}`)[0];
        const unitInput = control.querySelectorAll(`.js-product-unit-${id}`)[0];
        const buttonPlus = control.querySelectorAll(`.js-product-controls-up-${id}`)[0];
        const buttonMinus = control.querySelectorAll(`.js-product-controls-down-${id}`)[0];
        const minOrderQtyInput = control.querySelectorAll(`.min-order-qty-${id}`)[0];
        const minVal = parseFloat(minOrderQtyInput?.value);
        const minOrderQty = !!minOrderQtyInput && !!minOrderQtyInput?.value
            ? minVal === 0 ? 1 : Math.round(minVal)
            : 1;

        initProductQuantities = initProductQuantities.hasOwnProperty(id)
            ? {...initProductQuantities}
            : {...initProductQuantities, [id]: qtyInput.value};

        setAgreementForProduct(id);

        unitInput.addEventListener('change', (e) => {
            if (qtyInput.value.length <= 0 || qtyInput.value <= 0) {
                qtyInput.value = 0;
                updateUnitPrices(id, e.target.value);
                return
            }

            $(unitInput).val(e.target.value);
            sendCartAjax(qtyInput.value, e.target.value, id);
        });

        const updateCartFn = debounce((val, unitVal) => {
            sendCartAjax(val, unitVal, id);
        });

        buttonPlus.addEventListener('click', () => {
            const unit = unitInput.value;
            const val = addVal(qtyInput.value, getProperMinOrderQty(unit, minOrderQty));
            const unitVal = !!unitInput ? unitInput.value : '';

            updateQtyInput(id, val);
            updateCartFn(val, unitVal);
        });


        buttonMinus.addEventListener('click', () => {
            const unit = unitInput.value;
            const val = removeVal(qtyInput.value, getProperMinOrderQty(unit, minOrderQty));
            const unitVal = !!unitInput ? unitInput.value : '';

            updateQtyInput(id, val);
            updateCartFn(val, unitVal);
        });

        qtyInput.addEventListener('blur', () => {
            const unit = unitInput.value;
            if (qtyInput.value.length <= 0) {
                qtyInput.value = 0;
            }
            qtyInput.value = minStep(qtyInput.value, getProperMinOrderQty(unit, minOrderQty));
            const unitVal = !!unitInput ? unitInput.value : '';

            updateQtyInput(id, qtyInput.value);
            sendCartAjax(qtyInput.value, unitVal, id);
        });

        qtyInput.addEventListener('keypress', (e) => {
            if (e.which == 13) {
                qtyInput.blur();
                return false;
            }

            return true;
        });

        qtyInput.addEventListener("input", function (evt) {
            qtyInput.value = qtyInput.value.replace(/\D/g, "");

            if ((evt.which < 48 || evt.which > 57)) {
                evt.preventDefault();
            }
        });
    });
}

const setHoveringOnProductItems = (productItems) => {
    productItems.forEach(item => {
        const hoveredImage = item.querySelectorAll('.js-hovered-img')[0];
        const mainImage = item.querySelectorAll('.js-main-img')[0];
        const hoverImageContainer = item.querySelectorAll('.js-image-hover-container')[0];

        if (hoveredImage) {
            hoverImageContainer?.addEventListener('mouseover', () => {
                hoveredImage.style.display = 'block';
                mainImage.style.display = 'none';
            });

            hoverImageContainer?.addEventListener('mouseout', () => {
                hoveredImage.style.display = 'none';
                mainImage.style.display = 'block';
            });
        }
    })
}

const setAgreementForProduct = (id) => {
    const agreementData = document.querySelectorAll(`.js-product-agreement-${id}:not(.hidden)`)[0];
    const tender = document.querySelectorAll(`.js-agreement-${id}`);
    const agreement = agreementData?.dataset?.agreement;
    tender.forEach(t => {
        t.style.display = agreement === 'true' ? 'inline-block' : 'none';
    });
}

const updateUnitPrices = (id, unitValue) => {
    const unitPrices = document.querySelectorAll(`.js-price-product-${id}-${unitValue.toLowerCase()}`);

    unitPrices.forEach(unitPrice => {
        const volPrice = unitPrice.parentNode.querySelectorAll('.vol-price-products');
        volPrice.forEach(vol => {
            vol.classList.add("hidden");
            vol.querySelectorAll(`.js-product-agreement-${id}`)[0]?.classList?.add("hidden")
        });
        unitPrice.classList.remove("hidden");
        unitPrice.querySelectorAll(`.js-product-agreement-${id}`)[0]?.classList?.remove("hidden")
    });
}

// COLOR FUNCTIONS

const mapProductControls = (controls, callback) => {
    controls.forEach(control => {
        const id = control.dataset.id;
        const qtyInputs = control.querySelectorAll(`.js-product-qty-${id}`);
        const buttonsPlus = control.querySelectorAll(`.js-product-controls-up-${id}`);
        const buttonsMinus = control.querySelectorAll(`.js-product-controls-down-${id}`);

        callback(qtyInputs, buttonsPlus, buttonsMinus);
    });
};
const setControlsColorFunctionality = (controls) => {
    mapProductControls(controls, (qtyInputs, buttonsPlus, buttonsMinus) => {
        qtyInputs.forEach((qtyInput, idx) => {
            setQtyColor(qtyInput, buttonsPlus[idx], buttonsMinus[idx]);
            let observer = new MutationObserver(recs => setQtyColor(recs[0].target, buttonsPlus[idx], buttonsMinus[idx]));
            observer.observe(qtyInput, {attributes: true, attributeFilter: ['value']});
        });
    })
}

const setQtyColor = (target, btnPlus, btnMinus) => {
    if (target.value > 0) {
        target.classList.remove('empty');
        btnPlus.classList.remove('empty');
        btnMinus.classList.remove('empty');
        if(!customerPurchaseBlocked) {
            btnMinus.removeAttribute('disabled');
        }
    } else {
        target.classList.add('empty');
        btnPlus.classList.add('empty');
        btnMinus.classList.add('empty');
        btnMinus.setAttribute('disabled', true);
    }
}

const updateMiniCartDisplay = () => {
    const miniCartRefreshUrl = $(".js-mini-cart-link").data("miniCartRefreshUrl");

    sendGetPromise(miniCartRefreshUrl).then((jsonData) => {
        const numberItem = $("<span>").addClass("nav-items-total").text(jsonData.miniCartCount);
        $(".js-mini-cart-link .js-mini-cart-count").css('display', jsonData.miniCartCount > 0 ? 'block' : 'none');
        $(".js-mini-cart-link .js-mini-cart-count").empty();
        $(".js-mini-cart-link .js-mini-cart-count").append(numberItem);
        $(".js-mini-cart-link .price").text(jsonData.miniCartPrice);
    });
}

export {
    getCart,
    sendCartAjax,
    fetchProductSuggestions,
    showOutOfStockModal,
    showLimitedStockModal,
    isKarUnit,
    getProperMinOrderQty,
    addVal,
    removeVal,
    minStep,
    setFunctionalityOnControls,
    setAgreementForProduct,
    updateUnitPrices,
    mapProductControls,
    setControlsColorFunctionality,
    setHoveringOnProductItems,
    setQtyColor,
    updateMiniCartDisplay,
    updateQtyInput
}
